import { AxiosInstance } from "axios"
import { EmailsResend, SupportEmail } from "./emailTypes"
import { ServiceResponse } from "../../../../../core/api/apiTypes"

export enum SupportReportsEmailQuery {
    EMAILS_FOR_SUPPORT = "emails-for-support",
}

type SupportEmailsParams = Readonly<{
    subject?: string
    email?: string
    from?: string
    to?: string
}>

type EmailsResendProps = Readonly<{
    emails: Array<EmailsResend>
}>

export type SupportEmailsResponse = Readonly<{
    emails: SupportEmail[]
}>

export async function fetchSupportMessagesEmails(
    { from, to, subject, email }: SupportEmailsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SupportEmailsResponse> {
    const url = "/emails"
    const { data } = await axios.get(url, {
        params: {
            subject,
            email,
            from,
            to,
        },
        signal,
    })

    return data
}

export async function resendEmailApi(
    { emails }: EmailsResendProps,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = "/emails/resend"

    const response = await axios.post(
        url,
        {
            emails,
        },
        {
            signal,
        },
    )

    return response.data
}
